import React from 'react'
import { ENTER } from '../assets/constants/Constants';
import { useTranslation } from 'react-i18next';

export const CustomTextInput = ({
  value,
  onChange,
  type = "text",
  className = "",
  inputId = '',
  placeholder,
  multiline = false,
  handleKeyDown,
  autoFocus = false,
  rows = 3,
  inputProps = {},
  required = true,
  onEmpty,
  hasError,
  maxLength,
  disabled,
  errorMessage = null,
  placeholderClass = null,
  inputMode = 'text',
  editable = true
}) => {
  const { t } = useTranslation();

  const handleKeyEvents = (event) => {
    if (event.key === ENTER) {
      if (!disabled && handleKeyDown) {
        handleKeyDown();
        event.target.blur();
      }
    }
  };

  const commonProps = {
    id: inputId,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    autoFocus: autoFocus,
    required: required,
    maxLength: maxLength,
    disabled: disabled,
    onKeyDown: handleKeyEvents,
    inputMode: inputMode,
    readOnly: !editable,
    className: `${className} ${hasError ? 'input-error' : ''} ${placeholderClass || ''}`
  };

  return (
    <>
      {multiline ? (
        <textarea {...commonProps} rows={rows} />
      ) : (
        <>
        <p className='email-paragraph'>{t('enter_your_email_id_label')}</p>
        <input {...commonProps} type={type} />
        </>
      )}

      {errorMessage && (
        <p className="reason-validation-error">{errorMessage}</p>
      )}
    </>
  );
};